<template>
  <!-- Main Footer -->
  <footer class="main-footer">
    <!-- To the right -->
    <div class="pull-right hidden-xs">

    </div>
    <!-- Default to the left -->
    <strong>Copyright &copy; {{ annee }} <a href="http://www.abft.be">A.B.F.T.</a></strong> All rights reserved.
    <strong class="pull-right">V{{ getProdVersion }}</strong>
  </footer>
</template>

<script type="text/babel">
import {mapGetters, mapActions} from 'vuex'

var moment = require('moment')

export default {
  data() {
    return {
      annee: moment().year()
    }
  },
  computed: {
    ...mapGetters({
      getProdVersion: 'getProdVersion',
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Communs/Footer.vue